import type { Game } from '~/components/casino-shared/types';

export type RecommendedGamesResponse = {
	status: ResponseStatus;
	result: RecommendedGame[] | [];
};

export type RecommendedGame = Game & {
	inhouseJackpots: InhouseJackpot[];
};

export enum ResponseStatus {
	SUCCESS = 'SUCCESS',
	FAILURE = 'FAILURE'
}

type InhouseJackpot = {
	id?: string;
};
